// Copyright (c) 2021, Comsearch, Inc., All rights reserved

// argument is an Event (blur or paste prolly)

// takes the Event, and looks at the target's name attribute.
// this looks at the last part of the input's name so we can support stuff like
// sites[1]latitude -> latitude
const getAxisFromEventFieldName = ({ target }) => (
  target
    .getAttribute('name')
    .split(/[\].]/g)
    .pop()
)

export default getAxisFromEventFieldName
